// const API_URL = 'http://localhost:8080';
// const API_URL = 'http://192.168.1.33:8080';
// const API_URL = `http://${window.location.hostname}:8080`;
const API_URL = 'https://mediatest.vsmartengine.com';
export default API_URL;
